import React from 'react'
import PropTypes from 'prop-types'
import { useD3Selection } from 'hooks'
import { line } from 'd3'
import isNil from 'lodash/isNil'

function Curve({ data, color, dashed, curveFactory, ...props }) {
  const [ref, useSelectionEffect] = useD3Selection()

  // draw when new data or new scale
  useSelectionEffect(
    selection => {
      selection.attr(
        'd',
        line()
          .defined(({ x, y }) => !isNil(x) && !isNil(y))
          .curve(curveFactory)
          .x(({ x }) => x)
          .y(({ y }) => y)(data)
      )
    },
    [data]
  )

  return <path ref={ref} strokeDasharray={dashed ? '3, 3' : ''} stroke={color} fill="none" {...props} />
}

Curve.propTypes = {
  data: PropTypes.array,
  curveFactory: PropTypes.func,
  color: PropTypes.string,
  dashed: PropTypes.bool,
}

export default React.memo(Curve)
